module.exports = __webpack_public_path__ + "img/repair.6e3f504e.svg";